import { throttle } from 'lodash-es';
import { useEffect } from 'preact/hooks';

import { authStore } from '../../global-store/subjects/auth';
import { commonStore } from '../../global-store/subjects/common';
import logger from '../../services/logging/logging-service';
import { getInitialState } from '../../global-store/subjects/slim-banner-bottom';
import { initialState as commonInitialState } from '../../global-store/subjects/common/initial-state';
import { initialState as authInitialState } from '../../global-store/subjects/auth/initial-state';
import { BANNER_BOTTOM_STATUS, isSetOnLocalStorage } from '../../utils/local-storage';

import { useSubscribe } from './use-subscribe';

const SCROLL_THROTTLE_TIME = 1000; // milliseconds value
const SHOW_BANNER_THRESHOLD = 500; // pixels value
const initialState = getInitialState();

export const useToggleBottomBanner = ({ state, actions, htmlProps }) => {
  const authState = useSubscribe(authStore);
  const commonState = useSubscribe(commonStore);
  const isUserLoggedUnset = authState.isUserLogged === authInitialState.isUserLogged;
  const isUserLoggedInAndPreferencesUnset =
    htmlProps.isPersonalization && authState.isUserLogged && state.userPreferences === initialState.userPreferences;
  const isUserLoggedInAndErrorUnset = htmlProps.isPersonalization && authState.isUserLogged && state.error === initialState.error;
  const isPushNotificationShownUnset =
    commonState.isPushNotificationShown === commonInitialState.isPushNotificationShown;

  const isLoading =
    isUserLoggedUnset ||
    isUserLoggedInAndPreferencesUnset ||
    isUserLoggedInAndErrorUnset ||
    isPushNotificationShownUnset;

  const shouldCheckThreshold =
    !isLoading &&
    !(htmlProps.isPersonalization && authState.isUserLogged && state.userPreferences?.length) &&
    !state.error &&
    !commonState.isPushNotificationShown &&
    !isSetOnLocalStorage(BANNER_BOTTOM_STATUS.OBJECT_KEY);

  const checkThreshold = throttle(() => {
    if (window.scrollY > SHOW_BANNER_THRESHOLD) {
      actions.showBannerBottom();
      window.removeEventListener('scroll', checkThreshold);
    }
  }, SCROLL_THROTTLE_TIME);

  // Show the slim banner when it reaches the threshold
  useEffect(() => {
    if (shouldCheckThreshold) {
      logger.info(`
      [SBB] ----- utente non è loggato | utente è loggato senza aver scelto una preferenza | non ci sono errori da Appsync | utente sta visualizzando le push notification | utente ha già interagito con banner bottom
    `);
      window.addEventListener('scroll', checkThreshold);
      return () => window.removeEventListener('scroll', checkThreshold);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldCheckThreshold]);

  // Hide the slim banner when the HP is injected
  useEffect(() => {
    if (commonState.isInjectedHP) {
      actions.hideBannerBottom();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commonState.isInjectedHP]);
};
